import API_CONFIG from './api_config';

const registerCompany = async (company) => {
  try {
    const url = API_CONFIG.BACKEND_COMPANY_API_URL + '/companies';

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...company }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to register company!');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error registering company:', error.message);
    throw error;
  }
};

const getCompaniesRegisteredByLoggedInUser = async () => {
  try {
    const idToken = localStorage.getItem('authToken');
    const url = API_CONFIG.BACKEND_COMPANY_API_URL + '/users/companies';

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch companies');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching companies:', error.message);
    throw error;
  }
};

const getAllCompanies = async (lastKey = null) => {
  try {
    const params = new URLSearchParams();
    if (lastKey) params.append('lastKey', lastKey);
    params.append('limit', 10);

    const idToken = localStorage.getItem('authToken');
    const url =
      API_CONFIG.BACKEND_COMPANY_API_URL +
      `/admin/companies?${params.toString()}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch companies');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching companies:', error.message);
    throw error;
  }
};

export {
  registerCompany,
  getCompaniesRegisteredByLoggedInUser,
  getAllCompanies,
};
